import { getApiUrl } from '../../config';
import { storage } from '../../lib/storage';
import { notify } from '../../utils/toast';

export const verifyProfile = async (walletAddress: string): Promise<boolean> => {
  const loadingToastId = notify.loading('Verifying profile...');

  if (!walletAddress) {
    console.error('Invalid wallet address');
    notify.dismiss(loadingToastId);
    return false;
  }

  try {
    const token = localStorage.getItem('goplausible_token');
    if (!token) {
      console.log('No token found, profile verification skipped');
      notify.dismiss(loadingToastId);
      return false;
    }

    const response = await fetch(`${getApiUrl()}/profile/verify`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'referer': new URL(getApiUrl()).host
      },
      body: JSON.stringify({ walletAddress })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Profile verification failed');
    }

    notify.dismiss(loadingToastId);
    notify.success('Profile verified successfully');
    return true;
  } catch (error: any) {
    console.error('Profile verification error:', error);
    notify.dismiss(loadingToastId);
    notify.error(error.message || 'Failed to verify profile');
    return false;
  }
};